import BaseHelper from "./BaseHelper"
import {select as d3_select} from 'd3-selection'
export default class RootHelper extends BaseHelper {

  static configName = 'RootHelper'

  static init(){
    this.root = d3_select(this.$root).style('font-family',"santander-microtext-embedded")
  }
  
  static beforeDraw () {
    // this.size = this.$root.getBoundingClientRect()
    let content = d3_select(this.$root).selectAll('.content').data([null])
    this.content = content.merge(content.enter().append('g').attr('class','content'))
    // content.raise()
    
    // this.size = this.$root.getBoundingClientRect()
  }
  
  static draw () {
  }
  
  static afterDraw () {
    let root = d3_select(this.$root)
    root.select('.content').raise()
    root.select('.annotation-group').raise()
  }
  
}
